import {
  AutoComplete,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
} from "antd";
import "antd/dist/antd.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  type,
  option,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);

  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    let val = record[dataIndex];
    if (type === "createoption" && dataIndex === "option") {
      val = Array.isArray(val)
        ? val
            .map((v) => (Array.isArray(v) ? v[1] : v))
            .filter((v) => v !== undefined && v !== "")
        : (val ? [val].filter((v) => v !== undefined && v !== "") : []);
    }
    
    // Đảm bảo dấu (*) hiện đúng khi focus lần đầu vào input Tiêu đề
    if (dataIndex === "title") {
      const isRequired = record.required === true || record.required === "true" || (Array.isArray(record.required) && record.required[0] === "true");
      val = (val || "").replace(" (*)", "");
      if (isRequired) {
        val = `${val} (*)`;
      }
    }

    if (dataIndex === "validate") {
      try {
        val = typeof val === "string" ? val : JSON.stringify(val);
      } catch (e) {
        val = "";
      }
    }

    form.setFieldsValue({
      [dataIndex]: val,
    });
  };

  const save = async (e, dataIndex) => {
    try {
      // console.log(e.hasOwnProperty('target'));
      let value = !e.hasOwnProperty("target")
        ? e
        : e.target.type == "text"
          ? e.target.defaultValue
          : e.target.type == "checkbox"
            ? e.target.checked
            : "";

      if (dataIndex === "validate" && typeof value === "string" && value.trim() !== "") {
        try {
          value = JSON.parse(value);
          if (value && typeof value === 'object' && value.target) {
            value.target = value.target.replace(/\s*\(\*\)\s*/g, "").trim();
          }
        } catch (e) {
          // Keep as string if not valid JSON
        }
      }
      
      if (typeof value === 'string') {
        value = value.trim();
      }

      let valTitle = form.getFieldValue("title");
      let valRequired = form.getFieldValue("required");
      if (valTitle != undefined && valTitle != "") {
        if (dataIndex == "required") {
          var valTitle_re = valTitle.replace(" (*)", "");
          if (value == true && !valTitle.includes("(*)")) {
            valTitle_re = valTitle + " (*)";
          }
          record["title"] = valTitle_re;
          form.setFieldsValue({ title: valTitle_re });
        } else {
          if (valRequired != undefined) {
            if (valRequired[0] == "true") {
              if (!valTitle.includes("(*)")) {
                record["title"] = valTitle + " (*)";
                form.setFieldsValue({ title: valTitle + " (*)" });
              }
            } else {
              if (valTitle.includes("(*)")) {
                record["title"] = valTitle.replace(" (*)", "");
                form.setFieldsValue({ title: valTitle.replace(" (*)", "") });
              }
            }
          }
        }
      }

      // let value = typeof e === "string" ? e : e.target.defaultValue
      handleSave({ ...record }, value, dataIndex);
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };

  let childNode = children;

  if (editable && type == "text") {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input
          ref={inputRef}
          onPressEnter={(e) => save(e, dataIndex)}
          onBlur={(e) => save(e, dataIndex)}
        />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }
  if (editable && type == "checkbox") {
    childNode =
      1 === 1 ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          initialValue={record && record[dataIndex] === true ? ["true"] : []}
          rules={
            dataIndex === "Tiêu đề"
              ? [
                  {
                    required: true,
                    message: `${title} is required.`,
                  },
                ]
              : ""
          }
        >
          <Checkbox.Group ref={inputRef}>
            <Checkbox
              onPressEnter={(e) => save(e, dataIndex)}
              onChange={(e) => save(e, dataIndex)}
              value="true"
            ></Checkbox>
          </Checkbox.Group>
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
  }

  if (editable && type == "select") {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: false,
            message: `${title} is required.`,
          },
        ]}
        initialValue={"text"}
      >
        <Select
          style={{ width: "100%" }}
          ref={inputRef}
          onChange={(e) => save(e, dataIndex)}
          autoComplete={"off"}
        >
          <Select.Option value="text">text</Select.Option>
          <Select.Option value="number">number</Select.Option>
          <Select.Option value="date-text">date-text</Select.Option>
          <Select.Option value="range-date-text">range-date-text</Select.Option>
        </Select>
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  if (editable && type == "createoption") {
    const existingOptions = record ? record[dataIndex] : undefined;
    const initialValues = (() => {
      if (!existingOptions || existingOptions === "") return [];
      if (Array.isArray(existingOptions)) {
        return existingOptions
          .map((v) => (Array.isArray(v) ? v[1] : v))
          .filter((v) => v !== undefined && v !== "");
      }
      return [];
    })();

    childNode = editing ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        initialValue={initialValues}
      >
        <Select
          mode="tags"
          style={{ width: "100%", minWidth: 150 }}
          placeholder="Nhập và ấn Enter"
          ref={inputRef}
          open={false}
          onChange={(e) => save(e, dataIndex)}
          onBlur={toggleEdit}
        />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24, minHeight: 32 }}
        onClick={toggleEdit}
      >
        {initialValues.length > 0 ? (
          <Space size={[0, 4]} wrap>
            {initialValues.map((opt, i) => (
              <Tag key={i}>{opt}</Tag>
            ))}
          </Space>
        ) : (
          <span style={{ color: "#ccc" }}>Click để thêm tùy chọn...</span>
        )}
      </div>
    );
  }

  if (editable && type == "widthcol") {
    const options = [{ value: 50 }, { value: 100 }, { value: 200 }];
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: false,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input.Group compact>
          <AutoComplete
            style={{ width: "100%" }}
            placeholder=""
            options={[{ value: "50" }, { value: "100" }, { value: "200" }]}
            ref={inputRef}
            onPressEnter={(e) => save(e.target.value, dataIndex)}
            onBlur={(e) => save(e.target.value, dataIndex)}
            // onChange={(e) => {}}
          />
        </Input.Group>
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

class CreateTable extends React.Component {
  constructor(props) {
    super(props);

    this.props.isEditing
      ? (this.columns = [
          ...props.columns,
          {
            title: "",
            dataIndex: "operation",
            width: "8%",
            render: (text, record) =>
              this.state.dataSource.length > 0 ? (
                <Popconfirm
                  title="Chắc chắn xóa?"
                  onConfirm={() => this.handleDelete(record.key)}
                  okText="Lưu"
                >
                  <a style={{ color: "#ff0000" }}>Xóa</a>
                </Popconfirm>
              ) : null,
          },
        ])
      : (this.columns = [...props.columns]);

    this.state = {
      dataSource: this.props.dataSource,
      count: 2,
      items: [],
      name: "",
      title: this.props.title
        ? this.props.title
        : "Phần dành cho Bộ phận yêu cầu",
      editTable:
        this.props.initialEditTable !== undefined
          ? this.props.initialEditTable
          : true,
      displayColorPicker: false,
      color: this.props.color,
    };
  }

  handleDelete = (key) => {
    const dataSource = [...this.state.dataSource];
    const newData = dataSource.filter((item) => item.key !== key);
    this.setState({ dataSource: newData });
    this.props.callBackfunction(
      newData,
      this.state.title,
      this.state.editTable,
      `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
    );
  };
  handleAdd = () => {
    const { dataSource } = this.state;

    // Tìm key lớn nhất hiện có trong danh sách để sinh key mới an toàn, tránh trùng lặp
    const maxKey =
      dataSource.length > 0
        ? Math.max(...dataSource.map((item) => Number(item.key) || 0))
        : 0;
    const newKey = maxKey + 1;

    const newData = {
      key: newKey,
      type: "text",
      editable: this.state.editTable,
    };

    if (newKey <= 3) {
      // 3 cột đầu tiên
      newData.fixed = "left";
    }

    this.setState(
      {
        dataSource: [...dataSource, newData],
      },
      () => {
        // Cập nhật lên component cha để đồng bộ state ngay khi thêm
        this.props.callBackfunction(
          this.state.dataSource,
          this.state.title,
          this.state.editTable,
          `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
        );
      },
    );
  };

  handleSave = (row, newValue, dataIndex) => {
    const newData = [...this.state.dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];

    if (dataIndex == "option" && Object.entries(newValue).length == 0) {
      delete newData[index]["option"];
      newData.splice(index, 1, { ...item });
    } else {
      row[dataIndex] = newValue;
      newData.splice(index, 1, { ...item, ...row });
    }

    // console.log(newData)
    this.setState({
      dataSource: newData,
    });
    this.props.callBackfunction(
      newData,
      this.state.title,
      this.state.editTable,
      `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
    );
  };

  handleSaveHeader = (getTitle, editTable) => {
    const newData = [...this.state.dataSource];
    this.state.dataSource.map((row, index) => {
      const item = newData[index];
      row["editable"] = editTable;
      newData.splice(index, 1, { ...item, ...row });
    });

    this.props.callBackfunction(
      newData,
      getTitle,
      editTable,
      `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
    );
  };

  render() {
    const { dataSource } = this.state;
    // console.log(dataSource);

    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    };
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable.toString(),
          dataIndex: col.dataIndex,
          title: col.title,
          type: col.type,
          option: col.option,
          handleSave: this.handleSave,
        }),
      };
    });

    const onInputChange = (e) => {
      // console.log(e.target.value)
      this.setState({ title: e.target.value });
      this.handleSaveHeader(
        e.target.value,
        this.state.editTable,
        `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
      );
    };

    const onCheckChange = (e) => {
      this.setState({ editTable: !e.target.checked });
      this.handleSaveHeader(
        this.state.title,
        !e.target.checked,
        `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
      );
    };

    const handleClickColor = () => {
      this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    const handleCloseColor = () => {
      this.setState({ displayColorPicker: false });
    };

    const handleChangeColor = (color) => {
      this.setState({ color: color.rgb });
      this.handleSaveHeader(this.state.title, this.state.editTable, color.rgb);
    };

    const styles = reactCSS({
      default: {
        color: {
          width: "36px",
          height: "14px",
          borderRadius: "2px",
          background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
        },
        swatch: {
          padding: "5px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
        },
        popover: {
          position: "absolute",
          zIndex: "2",
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        },
      },
    });
    return (
      <Table
        components={this.props.isEditing ? components : null}
        rowClassName={() => "editable-row"}
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        style={{ padding: "16px 0px" }}
        scroll={{ x: "100%", y: 300 }}
        size="small"
        title={() => (
          <>
            <Row>
              <Col span={14} style={{ marginLeft: "16px" }}>
                <Input
                  placeholder={"Nhập tiêu đề"}
                  value={this.state.title}
                  onChange={onInputChange}
                  style={{
                    color: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
                  }}
                />
              </Col>
              <Col span={2} style={{ marginLeft: "10px", marginTop: "5px" }}>
                <Tooltip placement="topLeft" title={"Màu chữ phần tiêu đề"}>
                  <div style={styles.swatch} onClick={handleClickColor}>
                    <div style={styles.color} />
                  </div>
                  {this.state.displayColorPicker ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleCloseColor} />
                      <SketchPicker
                        color={this.state.color}
                        onChange={handleChangeColor}
                      />
                    </div>
                  ) : null}
                </Tooltip>
              </Col>
              <Col span={2} style={{ marginLeft: "5px" }}>
                <Tooltip
                  placement="topLeft"
                  title={'Tích "Khóa" đối với phần được truy cập theo bộ phận'}
                >
                  <Checkbox
                    onChange={(e) => onCheckChange(e)}
                    value="true"
                    checked={!this.state.editTable}
                    style={{ marginTop: "5px" }}
                  >
                    Khóa
                  </Checkbox>
                </Tooltip>
              </Col>
              <Col span={3} offset={1}>
                {this.props.isEditing ? (
                  <Button
                    onClick={this.handleAdd}
                    type="primary"
                    style={{
                      float: "right",
                    }}
                  >
                    Thêm trường
                  </Button>
                ) : null}
              </Col>
            </Row>
          </>
        )}
      />
    );
  }
}

export default CreateTable;
